document.querySelectorAll('.card-product-form').forEach((form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const submitButton = form.querySelector('button');
    const variantId = form.querySelector('.card-variant-select').value;

    submitButton.disabled = true;
    submitButton.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.href = '/checkout';
      });
  });
});

// Get all grid containers
document.querySelectorAll('section').forEach((wrp) => {
  if (!wrp.querySelector('.scroll-grid-container')) {
    return;
  }
  wrp.querySelectorAll('.scroll-grid-container').forEach((container) => {
    const gridId = container.querySelector('.scroll-grid').id;
    const grid = container.querySelector('.scroll-grid');
    const leftButton = container.querySelector(`.scroll-left[data-grid="${gridId}"]`);
    const rightButton = container.querySelector(`.scroll-right[data-grid="${gridId}"]`);

    const scrollAmount = 296; // 280px + 16px gap

    // Add click handlers for this specific grid
    if (leftButton) {
      leftButton.addEventListener('click', () => {
        grid.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth',
        });
      });
    }

    if (rightButton) {
      rightButton.addEventListener('click', () => {
        grid.scrollBy({
          left: scrollAmount,
          behavior: 'smooth',
        });
      });
    }
  });
});

// Tab switching for featured collection is handled in sections/featured-collection.liquid
